var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 47.98" }, props),
    React.createElement(
      "title",
      null,
      "block-icon-date-time"
    ),
    React.createElement(
      "g",
      { "data-name": "Layer 2" },
      React.createElement("path", { d: "M44 7.38h-4.37V3.5a3.51 3.51 0 0 0-3.5-3.5 3.51 3.51 0 0 0-3.5 3.5v3.88H15.44V3.5a3.51 3.51 0 0 0-3.5-3.5 3.51 3.51 0 0 0-3.5 3.5v3.88H4a4 4 0 0 0-4 4V44a4 4 0 0 0 4 4h40a4 4 0 0 0 4-4V11.38a4 4 0 0 0-4-4zM16.91 39.13h-4.55V24.6H6.73v-3.43A10.71 10.71 0 0 0 9 21a6 6 0 0 0 2-.74 4.87 4.87 0 0 0 1.49-1.39 5 5 0 0 0 .8-2.14h3.62zm22.37 0H22.83a9.34 9.34 0 0 1 .56-3.39 9 9 0 0 1 1.52-2.58 13.32 13.32 0 0 1 2.26-2.1q1.3-1 2.74-2 .74-.51 1.57-1A10.41 10.41 0 0 0 33 26.9a6.21 6.21 0 0 0 1.15-1.44 3.57 3.57 0 0 0 .46-1.82 3.37 3.37 0 0 0-.94-2.54 3.33 3.33 0 0 0-2.42-.91 2.93 2.93 0 0 0-1.68.46 3.46 3.46 0 0 0-1.1 1.22 5.59 5.59 0 0 0-.59 1.66 9.54 9.54 0 0 0-.18 1.81h-4.36a10.74 10.74 0 0 1 .45-3.57 8.3 8.3 0 0 1 1.54-2.88A7 7 0 0 1 27.9 17a8.73 8.73 0 0 1 3.57-.69 8.93 8.93 0 0 1 2.93.48 7.56 7.56 0 0 1 2.45 1.38 6.54 6.54 0 0 1 1.68 2.21 6.77 6.77 0 0 1 .62 2.94 7.1 7.1 0 0 1-.54 2.91 7.66 7.66 0 0 1-1.44 2.16 12.23 12.23 0 0 1-2 1.71l-2.29 1.52q-1.15.75-2.24 1.62a10.13 10.13 0 0 0-1.92 2h10.55z", "data-name": "Layer 1" })
    )
  );
});